import MDiaryDayMealSearch from "./MDiaryDayMealSearch";
import MDiaryDaySearch from "./MDiaryDaySearch";

export default class MDiaryDaySearchFactory
{
	static construct(el)
	{
		if (el.classList.contains('profile-diary-day-meal-search')) {
			return new MDiaryDayMealSearch(el);
		}

		return new MDiaryDaySearch(el);
	}
}
